import React from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import MotionReveal from "./MotionReveal";
import HomeSectionHeading from "./HomeSectionHeading";
import useMotionPreferences from "./useMotionPreferences";

export default function HomeFaq({ content }) {
  const { reducedMotion } = useMotionPreferences();

  return (
    <section className="public-home-premium__section public-home-premium__section--faq" id="faq">
      <div className="mx-auto flex w-full max-w-page flex-col gap-10 px-4 sm:px-6 lg:px-8">
        <HomeSectionHeading eyebrow={content.eyebrow} title={content.title} />

        <MotionReveal>
          <Accordion.Root type="single" collapsible className="public-home-premium__faq-root">
            {content.items.map((item, index) => (
              <Accordion.Item key={item.question} value={`faq-${index}`} className="public-home-premium__faq-item">
                <Accordion.Header>
                  <Accordion.Trigger className="public-home-premium__faq-trigger">
                    <span>{item.question}</span>
                    <motion.span
                      className="public-home-premium__faq-icon"
                      initial={false}
                      animate={{ rotate: 0 }}
                      transition={{ duration: reducedMotion ? 0 : 0.25 }}
                    >
                      <ChevronDown size={18} strokeWidth={1.7} />
                    </motion.span>
                  </Accordion.Trigger>
                </Accordion.Header>
                <Accordion.Content className="public-home-premium__faq-content" forceMount>
                  <p>{item.answer}</p>
                </Accordion.Content>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </MotionReveal>
      </div>
    </section>
  );
}
